export enum ReactAppEnvironment {
	DEVELOPMENT = "development",
	PRODUCTION = "production",
}

const environment = {
	env: process.env.REACT_APP_ENVIRONMENT as ReactAppEnvironment,
	standaloneAppUrl: process.env.REACT_APP_STANDALONE_APP_URL,
	mainAppUrl: process.env.REACT_APP_MAIN_APP_URL,
	deeplink: process.env.REACT_APP_DEEPLINK,
	googleTagManager: {
		trackingId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_TRACKING_ID,
	},
	firebaseConfig: {
		apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
		authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
		databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
		projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
		storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
		messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
		appId: process.env.REACT_APP_FIREBASE_APP_ID,
		measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
	},
};

export default environment;
